module.exports = __webpack_public_path__ + "static/img/value2.2c052b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/value2.png
// module id = MlM7
// module chunks = 1